import { useQuery } from '@tanstack/react-query';
import { httpJSON } from '../../../shared/api/http';

export function usePriceSparkQuery(symbol, options = {}) {
  const enabled = Boolean(symbol);
  return useQuery({
    queryKey: ['priceSpark', symbol],
    queryFn: () => httpJSON(`/v1/prices/sparkline/${symbol}`),
    enabled,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
}
